module.exports = __webpack_public_path__ + "img/xavier.3f891263.jpg";